import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly _activeRequests = signal<number>(0);
  readonly loading = computed(() => this._activeRequests() > 0);

  show() {
    this._activeRequests.update((count) => count + 1);
  }

  hide() {
    this._activeRequests.update((count) => Math.max(0, count - 1));
  }
}
